export const fileDownloadStatus = {
  CANCEL: '取消',
  FAILURE: '処理失敗',
  PROCESSING: '処理中',
  RESERVE: '予約',
  SUCCESS: '処理完了',
} as const;

export type FileDownloadStatusKey = keyof typeof fileDownloadStatus;

export const fileDownloadStatusKeys = Object.keys(fileDownloadStatus) as FileDownloadStatusKey[];

/** v-select用items */
export const fileDownloadStatusItems = fileDownloadStatusKeys
  .map((key) => ({
    title: fileDownloadStatus[key],
    value: key,
  }));
